const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20still%20of%20ancient%20Chinese%20palace%20hallway%20with%20soft%20candlelight%2C%20rich%20red%20silk%20drapes%2C%20atmospheric%20period%20drama%20scene%2C%20golden%20ambient%20glow%2C%20premium%20production%20quality%2C%20editorial%20photography&width=600&height=340&seq=97cinema-media-1&orientation=landscape',
    title: '《长安如故》幕后特辑',
    desc: '探访古装大剧拍摄现场',
    duration: '12:30',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20of%20modern%20Seoul%20skyline%20with%20warm%20city%20lights%2C%20reflective%20wet%20streets%2C%20atmospheric%20Korean%20drama%20mood%2C%20premium%20cinematographic%20quality%2C%20rich%20contrast%20with%20deep%20blues%20and%20golden%20highlights&width=600&height=340&seq=97cinema-media-2&orientation=landscape',
    title: '韩剧2024年度盘点',
    desc: '高分韩剧一次看个够',
    duration: '18:45',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20detective%20scene%20with%20warm%20desk%20lamp%20and%20scattered%20case%20files%2C%20film%20noir%20atmosphere%2C%20moody%20high%20contrast%20lighting%2C%20premium%20crime%20drama%20aesthetic%2C%20rich%20shadows%20and%20amber%20highlights&width=600&height=340&seq=97cinema-media-3&orientation=landscape',
    title: '美剧烧脑悬疑专场',
    desc: '十大高能反转美剧盘点',
    duration: '15:20',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20scene%20with%20floating%20lanterns%20and%20misty%20mountain%20peaks%2C%20soft%20magical%20glow%2C%20Chinese%20mythology%20aesthetic%2C%20dreamy%20cinematic%20composition%2C%20pearly%20golden%20light%2C%20premium%20visual%20effects%20quality&width=600&height=340&seq=97cinema-media-4&orientation=landscape',
    title: '仙侠剧名场面混剪',
    desc: '百年仙侠经典镜头回顾',
    duration: '22:10',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20ambient%20lighting%2C%20soft%20blankets%2C%20cinematic%20screen%20glow%2C%20romantic%20mood%2C%20intimate%20viewing%20experience%2C%20premium%20lifestyle%20photography%2C%20golden%20warm%20tones&width=600&height=340&seq=97cinema-media-5&orientation=landscape',
    title: '甜宠剧高甜瞬间集锦',
    desc: '治愈系糖分超标预警',
    duration: '10:55',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            精彩花絮
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            幕后特辑、精彩剪辑、年度盘点，更多追剧周边内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-black/50 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}